/* eslint-disable class-methods-use-this */

import axios, { AxiosResponse } from 'axios'

import { FetchClientSearchRequest } from '../model/customer.model'

export default class CustomerService {
  constructor(private apiGateway: string) {}

  fetchClientExists({
    value,
    tenant,
    validationType,
  }: {
    value: string
    tenant: string
    validationType: string
  }): Promise<boolean> {
    return axios
      .get(`${this.apiGateway}/customers/v1/${tenant}/customer/isCustomer`, {
        params: {
          validationType,
          value: value.toUpperCase(),
        },
      })
      .then((res) => res.data.isCustomer)
  }

  fetchClientSearch({
    tenant,
    body,
  }: {
    tenant: string
    body: FetchClientSearchRequest
  }): Promise<AxiosResponse> {
    return axios
      .post(`${this.apiGateway}/customers/v1/${tenant}/customer/search`, body, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response)
  }
}
